import { render, staticRenderFns } from "./layout-app.vue?vue&type=template&id=2e7a9f03"
import script from "./layout-app.vue?vue&type=script&lang=js"
export * from "./layout-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports